var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppSheetProjectElementLarge',{attrs:{"title":_vm.neighbourhoodSubdivision.name,"enter-to":_vm.neighbourhoodSubdivisionRouteObject,"exterior-tour360-to":_vm.exteriorTour360RouteObject,"logo-image-url":_vm.logoUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }